export const formatCep = (value?: string | null): string => {
  if (!value) return "";
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 8) {
    return value;
  }
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

const formatCpf = (digits: string): string => {
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
};

const formatCnpj = (digits: string): string => {
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
};

export const formatCpfCnpj = (value?: string | null): string => {
  if (!value) return "";
  const digits = value.replace(/\D/g, "");
  if (digits.length === 11) {
    return formatCpf(digits);
  }
  if (digits.length === 14) {
    return formatCnpj(digits);
  }
  return value;
};

const formatLocalPhone = (digits: string): string => {
  if (!digits) return "";
  if (digits.length === 9) {
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }
  if (digits.length === 8) {
    return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  }
  if (digits.length === 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return digits;
};

export const formatPhoneNumber = (
  phone?: string | null,
  options?: { ddd?: string | null; internationalCode?: string | null }
): string => {
  const digits = phone?.replace(/\D/g, "") ?? "";
  let areaCode = options?.ddd?.replace(/\D/g, "") ?? "";
  let localDigits = digits;

  if (!areaCode && (digits.length === 10 || digits.length === 11)) {
    areaCode = digits.slice(0, 2);
    localDigits = digits.slice(2);
  }

  const formattedLocal = formatLocalPhone(localDigits);

  if (!formattedLocal && !areaCode) {
    return "";
  }

  if (!formattedLocal) {
    return `(${areaCode})`;
  }

  const prefix = areaCode ? `(${areaCode}) ` : "";
  const internationalCode = options?.internationalCode
    ?.replace(/\D/g, "")
    .replace(/^0+/, "");

  const internationalPrefix = internationalCode
    ? `+${internationalCode} `
    : "";

  if (prefix) {
    return `${internationalPrefix}${prefix}${formattedLocal}`.trim();
  }

  return `${internationalPrefix}${formattedLocal}`.trim();
};

export const formatDddPhone = (
  ddd?: string | null,
  phone?: string | null,
  internationalCode?: string | null
): string => {
  return formatPhoneNumber(phone, { ddd, internationalCode });
};

export const formatDocument = (value?: string | null): string => {
  return formatCpfCnpj(value);
};

export const formatWhatsappLink = (
  ddd?: string | null,
  phone?: string | null,
  internationalCode = "55"
): string | null => {
  const dddDigits = ddd?.replace(/\D/g, "") ?? "";
  const phoneDigits = phone?.replace(/\D/g, "") ?? "";
  const countryDigits = internationalCode.replace(/\D/g, "") || "55";

  if (!phoneDigits) {
    return null;
  }

  const areaCode = dddDigits || (phoneDigits.length >= 10 ? phoneDigits.slice(0, 2) : "");
  const localNumber = dddDigits ? phoneDigits : phoneDigits.slice(areaCode ? 2 : 0);
  const completeNumber = `${countryDigits}${areaCode}${localNumber}`;

  return `https://wa.me/${completeNumber}`;
};
